(function ($) {
	var tvProduct = function() {
		var cls = this;
		{
			cls.broadTypCd = $('#broadTypCd').val();
			cls.today = $('#broadToday').val();
			cls.remainTime = $('#rtime');
			cls.onAirPrd = $('#on-air-prd');
			cls.moreViewYn = 'N';
			cls.boardLoading;
			cls.boardReloading;
			cls.onAirPlayer = window.onAirPlayer;

			cls.params = {
				pageIdx: 1,
				// pageItemSize: 36,
				pageItemSize: 72,
				sectid  : 0,
				// msectid : 0,
				orderBy : "",
				today   : cls.today,
			};
			cls.refreshOnAirParam = {
				currentBroadUrl: '',
				currentBroadTarget: 'on-air-prd',
				today: cls.today
			};
		}

		cls.init = function() {
			cls.setEvent();
			if (document.location.hash) {
				var hashArray = cls.handleHash();
				if( hashArray.length == 3){
					cls.broadTypCd = hashArray[0];
					cls.sectId	= hashArray[1];
					cls.moreViewYn = hashArray[2];
					cls.viewBestCategory();
					setTimeout(function() {
						$('#on-air-tab li[data-broad-type="'+cls.broadTypCd+'"] a').trigger('click');
					}, 100);
				}
			} else {
				// TV BEST 상품 조회
				cls.changeCategoryBest();
			}
			cls.refreshOnAirParam = cls.getRefreshOnAirParam(cls.broadTypCd);
			cls.refreshOnAir(cls.refreshOnAirParam);
			cls.onAirCountDown();

			// muted true 처리
			cls.onAirPlayer.playerController.find('.volume').addClass('off');
		}

		cls.setEvent = function() {
			// TV BEST > 상품 더보기 버튼 클릭
			$('#moreBtn').off('click.moreBtn').on('click.moreBtn', function (){
				cls.viewMorePrdList();
				cls.moreViewYn = "Y";
				cls.changeHash();
			});

			// ON-AIR 채널(LIVE/DATA) 탭 이벤트
			$('#on-air-tab').tab({
				callbackFn: function(el, wrapper, targetId) {
					cls.broadTypCd = el.find('li.item.on').data('broad-type');
					cls.refreshOnAirParam = cls.getRefreshOnAirParam(cls.broadTypCd);
					// ON-AIR 영역 새로고침
					cls.refreshOnAir(cls.refreshOnAirParam);
					// ON-AIR 스트리밍 url 변경
					cls.onAirPlayer.resetStreamUrl(cls.broadTypCd);
					// 효율코드 dummyLog 호출
					cls.callLseq(cls.broadTypCd);
					cls.changeHash();
				}
			});

			// 방송 편성표 URL
			$('#schedule-link').off('click.scheduleLink').on('click.scheduleLink', function(e){
				e.preventDefault();
				// 방송 타입에 따라 편성표 URL 변경
				var broadScheduleUrl = cls.isTvLive(cls.broadTypCd) ? "/shop/tv/tvScheduleMain.gs" : "/shop/tv/dataScheduleMain.gs";
				location.href = broadScheduleUrl + "?lseq=" + LSeqUtil.getLseq("broadSchedule");
			});

			// TV BEST 탭
			$('#detail-tab').tab({
				callbackFn: function() {
					cls.moreViewYn = 'N';
					// 카테고리 별 상품 리스트 조회
					cls.changeCategoryBest();
					cls.changeHash();
				}
			});

			// GS Exclusive 브랜드 swiper
			$('[data-swipe=exclusive-swiper]').gsSwiper({
				autoplay:0,
				speed:0,
				slidesPerView:6,
				slidesPerGroup:6,
				rePerView:5,
				// slideIS:true,
				resizeIS:true,
			});

			// 방송중 상품 더보기 버튼
			cls.onAirPrd.off('click').on('click', '.btn-more', function(e){
				if( cls.onAirPrd.hasClass('on') ){
					cls.onAirPrd.removeClass('on');
					$(this).find('strong').text('방송중 상품 더보기');
				} else{
					cls.onAirPrd.addClass('on');
					$(this).find('strong').text('닫기');
				}
			});
		}

		cls.viewBestCategory = function() {
			var category = $('#detail-tab li a[tab-kind="' + cls.sectId + '"]');
			category.parent().siblings().removeClass('on');
			category.parent().addClass('on');
			cls.changeCategoryBest(cls.sectId);
		}

		cls.viewMorePrdList = function() {
			$("#prd-list > li").show();
			$('#moreBtn').addClass('hide');
		}

		// 효율코드 dummyLog 호출
		cls.callLseq = function(broadTypCd) {
			var lseqType = cls.isTvLive(broadTypCd) ? 'gsShopliveTab' : 'gsMyShopTab';
			LSeqUtil.recodeLseq(lseqType);
		}

		// SHOP LIVE 방송 여부 체크
		cls.isTvLive = function(broadTypCd) {
			// true : LIVE 방송 / false : DATA 방송
			return "LIVE" == broadTypCd;
		}

		// 방송 타입(LIVE/DATA) 별 param 정보 셋팅
		cls.getRefreshOnAirParam = function(broadTypCd) {
			var param = cls.refreshOnAirParam;
			param.currentBroadUrl = cls.isTvLive(broadTypCd) ?
				 '/shop/tv/ajax/refreshCurrentTvBroad.gs?today=' : '/shop/tv/ajax/refreshCurrentDataBroad.gs?today=';
			return param;
		}

		// ON-AIR 동영상 영역 카운트다운
		cls.onAirCountDown = function() {
			if ( cls.remainTime.length > 0 ) {
				cls.remainTime.on('update.countdown', function( event ){
					var format = '%H:%M:%S';
					if ( event.offset.totalDays > 0 ) {
						format = '%-d<span class="day-txt">Day</span>%!d ' + format;
					}
					$(this).html( event.strftime(format) );
				})
				.on('finish.countdown', function(){
					cls.remainTime.html('00:00:00');
					cls.refreshOnAirParam.today = "";
					cls.refreshOnAir(cls.refreshOnAirParam);
				});
			}
		}

		/*
         * 현재 방송 ajax call - 수정 by 이재욱 k
         * @param refreshOnAirParam
         */
		cls.getCurrentBroadHtml = function(refreshOnAirParam) {
			$.ajax({
				url: refreshOnAirParam.currentBroadUrl + refreshOnAirParam.today,
			})
			.done( function( data ) {
				var closingDt = parseInt( $('#closingDt', data).val() );
				if( cls.boardReloading ){
					clearTimeout( cls.boardReloading );
					cls.boardReloading = null;
				}
				$('#on-air-prd').html( data );
				cls.onAirPrd.removeClass('on');
				if ( closingDt ) {
					clearTimeout( cls.boardLoading );
					cls.boardLoading = null;
					// 로컬 시간
					var now = new Date();
					var nowDt = now.getTime();
					// 로컬 시간이랑 차이가 있을시 30초 간격으로 재호출
					if ( nowDt > closingDt ) {
						cls.boardLoading = setTimeout(function(){
							refreshOnAirParam.today = "";
							cls.refreshOnAir(refreshOnAirParam);
						}, 30000);
					} else {
						cls.remainTime.countdown( closingDt );
					}
				} else {
					//종료 타임 정보 에러가 났을 경우 1분 간격 재호출
					cls.boardReloading = setTimeout(function(){
						refreshOnAirParam.today = "";
						cls.refreshOnAir(refreshOnAirParam);
					}, 60 * 1000);
				}
			});
		}

		// 현재 방송 refresh
		cls.refreshOnAir = function(refreshOnAirParam) {
			// 현재 방송 데이터 조회
			// refreshOnAirParam.today = "";
			// refreshOnAirParam.today = cls.today;
			cls.getCurrentBroadHtml(refreshOnAirParam);
		}

		cls.moveToLatestItem = function(latestViewedItem){
			if ( latestViewedItem && $(latestViewedItem).length > 0 ){
				scrollPosition = $(latestViewedItem).offset().top;
				$('html, body').scrollTop( scrollPosition );
				window.sessionStorage.removeItem("RB_VIEWED_PRDCD");
			}
		}

		// TV BEST > 카테고리 별 상품 리스트 조회
		cls.changeCategoryBest = function(sectId){
			var target = sectId ? $('#detail-tab li a[tab-kind="'+cls.sectId+'"]') : $('#detailLnb .on a');
			var param = cls.params;
			param.sectid = target.attr('tab-kind');
			param.lseq = target.data('lseq');
			param.orderBy = $('#sortType').val();
			cls.getBestPrdList(param);
		}

		cls.getBestPrdList = function(param) {
			var url = "/shop/tv/tvProductBest.gs";
			$.ajax({
				url  : url,
				type : 'GET',
				data : param,
				dataType: 'html',
				success : function(data) {
					$("#u_prdlst").html(data);

					var totCnt = Number ( $('#totCnt').val() ) ;
					if( totCnt > 36) {
						$('#moreBtn').removeClass('hide');
					}else {
						$('#moreBtn').addClass('hide');
					}

					if("Y" == cls.moreViewYn) {
						// $('#moreBtn').trigger('click');
						cls.viewMorePrdList();
						cls.moreViewYn = "N";
					}
					if (window.sessionStorage){
						if (window.sessionStorage.getItem("RB_VIEWED_PRDCD")){
							var prdCd = window.sessionStorage.getItem("RB_VIEWED_PRDCD");
							if (prdCd){
								var latestViewedItem = "[data-prdid='"+prdCd+"']";
								cls.moveToLatestItem(latestViewedItem);
							}
						}
					}
				}
			});
		}

		cls.changeHash = function() {
			var params = cls.params;
			var hash = cls.broadTypCd + "|" + params.sectid + "|" + cls.moreViewYn;
			document.location.hash = hash;
		}

		cls.handleHash = function(){
			if (document.location.hash) {
				var hash = document.location.hash.substring(1);
				var hashArray = hash.split("|");
				return hashArray;
			}
		}
	}
	window.tvProduct = window.tvProduct || new tvProduct();
	window.tvProduct.init();
})(jQuery);